import "./Date.scss";

import React from "react";
import DatePicker from "react-datepicker";
import Moment from "moment";
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MaskedInput from "react-text-mask";
import DateInput from "Components/common/Functions/DatePicker/DateInput/DateInput";

class Date extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null
        }
    }

    render() {
        const { value } = this.props;
        const open = Boolean(this.state.anchorEl);

        const handleChange = date => {
             this.props.onChange(date?Moment(date).format("MM/DD/YYYY"):null)  
        }

        const handleClick = (event) => {
            this.setState({...this.state, anchorEl: event.currentTarget});
        }
        
        const handleClose = () => {
            this.setState({...this.state, anchorEl: null});
        }

        return (
            <div key={`periodTypeKey_${this.props.id}`} class="formContainer">
                <a onClick={handleClick}>
                    <DateInput
                        value={value}
                        onChange={handleChange}
                        allowNull
                    />
                    {/* <MaskedInput guide={false} mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]} placeholder="mm/dd/yyyy" type="text" class="form-control" value={value} onChange={handleInputChange} onBlur={handleInputBlur} /> */}
                </a>
                <Popper
                    id={this.props.id}
                    open={open}
                    anchorEl={this.state.anchorEl}
                    placement="bottom-start"
                    style={{ zIndex: 3 }}
                >
                    <ClickAwayListener onClickAway={handleClose}>
                        <div class="accountCalendarDatePicker">
                            <DatePicker 
                                inline
                                useWeekdaysShort={true}
                                shouldCloseOnSelect={false}
                                selected={value ? Moment(value).toDate() : null}
                                onChange={handleChange}
                            />
                        </div>
                    </ClickAwayListener>
                </Popper>
            </div>
        );
    }
}

export default Date;